import React from 'react';

export function EyeconClosedSVG({ className }: { className: string }) {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.4" clipPath="url(#clip0)">
                <g clipPath="url(#clip1)">
                    <path
                        d="M1.5 12C1.5 12 4.9 4 12.5 4"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M16.8 4.9C15.5 4.4 14.1 4 12.5 4"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M23.4996 12C23.4996 12 22.3996 9.50005 20.0996 7.30005"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M23.5 12C23.5 12 20.1 20 12.5 20"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.2002 19.1001C9.5002 19.6001 10.9002 20.0001 12.5002 20.0001"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M1.5 12C1.5 12 2.6 14.6 4.9 16.8"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.5 12.2C9.5 12.1 9.5 12.1 9.5 12C9.5 10.3 10.8 9 12.5 9C12.6 9 12.6 9 12.7 9"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M15.4998 11.8C15.4998 11.9 15.4998 11.9 15.4998 12C15.4998 13.7 14.1998 15 12.4998 15C12.3998 15 12.3998 15 12.2998 15"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2.40039 20.0999L20.6004 1.8999"
                        stroke="#0A2545"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
                <clipPath id="clip1">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
